module.exports = __webpack_public_path__ + "df4cf4e18e57cb68cb19a1ff7035e3a6.png";